const env = process.env.NODE_ENV === 'development' || window.location.hostname === 'testmiljo.nettserier.no' ? 'development' : 'production';

const site = {
	api: env === 'development' ? 'https://testapi.nettserier.no/v4/' : 'https://api.nettserier.no/v4/',
	media: env === 'development' ? 'https://testapi.nettserier.no/media/' : 'https://media.nettserier.no/',
	env: env,

};

export default site;